import styled from 'styled-components'

const StyledLessonSidebarModule = styled.div`
  .module-header-btn {
    padding: 14px;
    text-align: left;
    width: 100%;
    box-sizing: border-box;
    background-color: transparent;
    transition: 0.2s;

    .module-header-top {
      width: 100%;
      display: flex;

      .module-title {
        font-size: 13px;
        font-weight: 500;
        width: 100%;
        color: ${({ theme }) => theme.color.gray[900]};
      }

      svg {
        position: relative;
        right: -2px;
        top: -2px;
        height: 18px;
        width: 18px;
        stroke-width: 2.5px;
        flex-shrink: 0;
        margin-left: 14px;
        color: ${({ theme }) => theme.color.gray[400]};
      }
    }

    .module-header-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      margin-top: 4px;
      color: ${({ theme }) => theme.color.gray[500]};
    }

    &:hover {
      background-color: ${({ theme }) => theme.color.gray[200]};
    }
  }

  .module-lesson-list {
    padding: 0 14px 14px 14px;
    display: grid;
    gap: 12px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.color.gray[300]};
  }
`

export default StyledLessonSidebarModule
